export const filterOptions = (data, attribute) => {
    if (Array.isArray(data)) {
        const result = [...new Set(data.map(item => item[attribute]))]
        return result;
    };
    return [];
};